import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';

interface MICRState {
  rawData: string;
  routingNumber: string;
  accountNumber: string;
  checkNumber: string;
  amount: string;
}

const initialState: MICRState = {
  rawData: '',
  routingNumber: '',
  accountNumber: '',
  checkNumber: '',
  amount: '',
};

export class MICRReducer extends ImmerReducer<MICRState> {
  public setMICRData(webSocketResponse): void {
    this.draftState.rawData = webSocketResponse.rawData;
    this.draftState.routingNumber = webSocketResponse.routingNumber;
    this.draftState.accountNumber = webSocketResponse.accountNumber;
    this.draftState.checkNumber = webSocketResponse.checkNumber;
    this.draftState.amount = webSocketResponse.amount;
  }
  public resetMICRData(): void {
    this.draftState = initialState;
  }
}

export const MICRActions = createActionCreators(MICRReducer);
export const MICRReducerFunction = createReducerFunction(MICRReducer, initialState);
